import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Typography,
  Button,
  Divider,
  Spin,
  Popconfirm,
  notification
} from 'antd';
import {
  getCourseOfferById,
  getInitialValuesFromExistingCourseOffer
} from '../../services/courseOfferService';
import { getCourse } from '../../services/courseService';
import ActionHeader from '../../components/Common/ActionHeader';
import UnitOfferSection from '../../components/unitOffer/UnitOfferSection';
import CourseOfferForm from '../../components/courseOffer/CourseOfferForm';
import {
  setCurrentCloneCourseOffer,
  setCurrentCourseOffer,
  setSubmitSuccess
} from '../../actions/courseOffer';
import { COHORT_OFFER_TYPES } from '../../utilities/constants';

const { Title } = Typography;

const CloneCourseOfferContainer = ({
  courseOffer,
  unitOffers,
  errors,
  success,
  loading,
  dispatch
}) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isPricingModalVisible, setIsPricingModalVisible] = useState(
    false
  );

  const [initialValues, setInitialValues] = useState(null);
  const [courseOfferState, setCourseOfferState] = useState(null);
  const [course, setCourse] = useState(null);
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });
  const isCohortCourseClone = COHORT_OFFER_TYPES.includes(
    courseOffer.type
  );

  if (isCohortCourseClone === true) courseOffer.code = ''; //When cloning cohort course, we don't need to input courseCode

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    const initValues = getInitialValuesFromExistingCourseOffer(
      courseOfferState,
      'clone'
    );
    setInitialValues(initValues);
  }, [courseOfferState]);

  const fetchData = async () => {
    setIsLoading(true);
    await getCourseOfferById(id)
      .then((response) => {
        if (response.data.length !== 0) {
          const courseOffer = {
            ...response.data,
            startDate: moment(response.data.startDate),
            endDate: moment(response.data.endDate),
            trainers: response.data.trainers
              ? response.data.trainers.map((trainer) => {
                  return trainer.trainerId;
                })
              : [],
            pricingOptions: response.data.pricingOptions?._id
          };
          getCourse({
            courseId: response.data.courseId
          }).then((response) => {
            setCourse(response.data.course);
          });

          dispatch(setCurrentCourseOffer(courseOffer));
          setCourseOfferState(courseOffer);
        } else {
          throw Error('This course offer does not exist!');
        }
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
    setIsLoading(false);
  };

  const onSubmit = async (values) => {
    const newData = {
      ...courseOffer,
      code: values.code,
      description: values.description,
      courseDescription: values.description,
      wave: parseInt(values.wave),
      groupNumber: parseInt(values.groupNumber),
      startDate: moment(values.startDate),
      endDate: moment(values.endDate),
      frequency: values.frequency,
      trainers: values.trainers,
      whatsappGroupLinks: values.whatsappGroupLinks,
      discordGroupLink: values.discordGroupLink,
      communityPlatforms: values.communityPlatforms,
      liveSessions: values.liveSessions
    };

    dispatch(setCurrentCourseOffer(newData));
    dispatch(
      setSubmitSuccess([
        { message: `Saved course offer info for ${newData.code}` }
      ])
    );
  };

  const onClone = () => {
    dispatch(setCurrentCloneCourseOffer(courseOffer, unitOffers));
  };

  const openNotificationWithIcon = (type, title, msg, duration) => {
    notification[type]({
      message: title,
      description: msg,
      duration
    });
  };

  useEffect(() => {
    success.map((msg) => {
      openNotificationWithIcon('success', msg.message, '', 5);
    });
  }, [success]);

  useEffect(() => {
    errors.map((err) => {
      openNotificationWithIcon('error', err.message, err.message, 5);
    });
  }, [errors]);

  useEffect(() => {
    if (loading) {
      openNotificationWithIcon(
        'warning',
        'DO NOT CLOSE WINDOW!',
        'Cloning course offer',
        5
      );
    }
  }, [loading]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px'
          }}>
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <ActionHeader
            title={
              'Cloning Course Offer ' +
              courseOffer?.code +
              ': ' +
              courseOffer?.description
            }
          />
          <br />
          {courseOffer?.courseCode && course && (
            <section>
              <CourseOfferForm
                type="Clone"
                initialValues={initialValues}
                onSubmit={onSubmit}
                status={status}
                course={course}
                isCohortCourseClone={isCohortCourseClone}
                visible={true}
                isPricingModalVisible={isPricingModalVisible}
                setIsPricingModalVisible={setIsPricingModalVisible}
              />
            </section>
          )}
          <Divider />
          <br />
          {courseOffer?.courseCode && (
            <UnitOfferSection cloning={true} courseOffer={courseOffer} />
          )}
          <div
            style={{
              float: 'right',
              position: 'relative'
            }}>
            <Popconfirm
              title="Sure to submit?"
              onConfirm={() => onClone()}>
              <Button type="primary">Clone</Button>
            </Popconfirm>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  courseOffer: state.courseOffer.courseOffer,
  success: state.courseOffer.success,
  errors: state.courseOffer.errors,
  loading: state.courseOffer.loading,
  unitOffers: state.unitOffer.unitOffers
});

export default connect(mapStateToProps)(
  withRouter(CloneCourseOfferContainer)
);
